import * as yup from 'yup'
import { VALIDATION } from 'utils/globalConstant'

export const validationSchema = yup.object({
  overtime_date: yup.string().required(VALIDATION.required),
  overtime_start: yup.string().required(VALIDATION.required),
  overtime_end: yup.string().required(VALIDATION.required),
  classification: yup.string().required(VALIDATION.required),
  reason: yup.string().required(VALIDATION.required),
})
